import { useEffect, useState } from "react";
import { integrationsApi } from "../../lib/api/integrations.js";
import "./Integrations.css";

export function Integrations() {
  const [enabled, setEnabled] = useState(false);
  const [url, setUrl] = useState<string | null>(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    integrationsApi.calendarStatus().then((r) => {
      if (r.success && r.data) setEnabled(r.data.enabled);
    });
  }, []);

  async function enable() {
    const r = await integrationsApi.enableCalendar();
    if (r.success && r.data) {
      setEnabled(true);
      setUrl(r.data.url);
    }
  }
  async function disable() {
    await integrationsApi.disableCalendar();
    setEnabled(false);
    setUrl(null);
  }
  function copy() {
    if (!url) return;
    navigator.clipboard?.writeText(url).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  }

  return (
    <section className="intg">
      <h1 className="intg__h1">Export &amp; integrations</h1>

      <div className="intg__card">
        <h2 className="intg__h2">Calendar subscribe feed</h2>
        <p className="intg__sub">
          Subscribe to your own travel from Google/Apple Calendar — it auto-updates. Medical &amp;
          time-off show only as “Away”.
        </p>
        {enabled ? (
          <>
            {url && (
              <div className="intg__feed">
                <code className="intg__url">{url}</code>
                <button type="button" className="intg__btn" onClick={copy}>
                  {copied ? "Copied ✓" : "Copy"}
                </button>
              </div>
            )}
            <div className="intg__row">
              {!url && (
                <button type="button" className="intg__btn" onClick={enable}>
                  Show link
                </button>
              )}
              <button type="button" className="intg__btn intg__btn-danger" onClick={disable}>
                Turn off
              </button>
            </div>
          </>
        ) : (
          <button type="button" className="btn btn-primary" onClick={enable}>
            Enable subscribe feed
          </button>
        )}
      </div>

      <div className="intg__card">
        <h2 className="intg__h2">Notion / Markdown</h2>
        <p className="intg__sub">Download your travel as a markdown table to paste anywhere.</p>
        <a className="btn btn-primary intg__dl" href={integrationsApi.markdownHref} download>
          Download .md
        </a>
      </div>

      <div className="intg__card intg__card--soon">
        <h2 className="intg__h2">Import from Google Calendar</h2>
        <p className="intg__sub">
          Coming soon — pull trips from your calendar automatically (needs Google Calendar access).
        </p>
      </div>
    </section>
  );
}
